<template>
	<div>
		<v-app-bar flat app color="primary" dark>
			<v-app-bar-nav-icon @click.stop="clickDrawer"></v-app-bar-nav-icon>
			<v-menu offset-y v-if="false">
				<template v-slot:activator="{ on, attrs }">
					<v-btn dark text v-bind="attrs" v-on="on">
						<v-icon>mdi-plus-circle</v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item link>
						<v-icon class="text-body-2">mdi-cart</v-icon>
						<v-list-item-content class="pl-2">
							<v-list-item-title class="text-body-2">Tambah Keranjang</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
					<v-list-item link>
						<v-icon class="text-body-2">mdi-plus</v-icon>
						<v-list-item-content class="pl-2">
							<v-list-item-title class="text-body-2">Tambah Menu</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
			<v-text-field v-if="false" class="mx-4" flat hide-details label="Search" prepend-inner-icon="mdi-magnify" solo-inverted></v-text-field>
			<v-spacer></v-spacer>
			<v-btn text @click="onFullscreen" color="white" v-if="!fullscreen">
				<v-icon>mdi-fullscreen</v-icon>
			</v-btn>
			<v-btn text @click="exitFullscreen" color="white" v-else>
				<v-icon>mdi-fullscreen-exit</v-icon>
			</v-btn>
			<v-menu open-on-hover offset-y>
				<template v-slot:activator="{ on, attrs }">
					<v-btn dark text v-bind="attrs" v-on="on">
						{{ userData.user_name }}
						<v-icon>mdi-chevron-down</v-icon>
					</v-btn>
				</template>
				<v-list>
					<router-link class="text-deco" :to="{ name: 'profile'}">
						<v-list-item link>
							<v-icon class="pr-3">mdi-account</v-icon>
							<v-list-item-content>
								<v-list-item-title>Profil</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<v-list-item link @click.native="onLogout">
						<v-icon class="pr-3">mdi-exit-to-app</v-icon>
						<v-list-item-content>
							<v-list-item-title>Logout</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
	</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions, mapState } = createNamespacedHelpers('auth');

export default {
	data() {
		return {
			fullscreen: false,
		}
	},
	computed: {
		...mapState(['userData']),
	},
	methods: {
		...mapActions(['logout']),

		onLogout() {
			this.logout().then( () => {
				this.$router.push({ name: 'login' })
			} )
		},
		clickDrawer() {
			this.$emit('childToParent')
		},
		onFullscreen() {
			let elem = document.getElementById("app");
			if (elem.requestFullscreen) {
				elem.requestFullscreen()
			} else if (elem.mozRequestFullScreen) {
				elem.mozRequestFullScreen()
			} else if (elem.webkitRequestFullscreen) {
				elem.webkitRequestFullscreen()
			} else if (elem.msRequestFullscreen) {
				elem.msRequestFullscreen()
			}
			this.fullscreen = true
		},
		exitFullscreen() {
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen()
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen()
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen()
			}
			this.fullscreen = false
		}
	}
}
</script>